import React, { Component } from 'react'
import metadataJson from '../assets/metadata_completed.json';
import '../style/ExploreFrog.css'
export class ExploreFrog extends Component {

    constructor() {
        super();
        this.frogID = window.location.href.split("/explore/")[1];
        this.frog = metadataJson[this.frogID.toString()]
    }

    render() {
        return (
            <div id="exploreFrog" >
                <div className="explore-frog-tile">
                    <img src={`https://ipfs.blockfrost.dev/ipfs/${this.frog.image.replace("ipfs://", "")}`} alt="" id="exploreFrogImg" />
                    <span id="exploreFrogSpan">{this.frog.name}</span>
                    
                </div>
                <div id="exploreFrogTraits">
                        <div className="explore-frog-trait">{this.frog.body}</div>
                        {this.frog.gadgets.map(gadget => (<div className="explore-frog-trait">{gadget}</div>))}
                    </div>
            </div>

        )
    }
}

export default ExploreFrog
